import { Card } from 'antd'
import { imDfmFeedback_quoteModelRevision_dfmFeedback_topic as DfmFeedbackTopicType } from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/__generated__/imDfmFeedback'

import Box from '~/core/Box'
import Text from '~/core/Text'
import { DFM_STATES, ImDfmStateType } from '../constants'
import SlideActions from '../SlideActions'
import StatusOverviewIcon from '../InactiveSlide/StatusOverviewIcon'
import TagLabel from '../ActiveSlide/ActiveSlideTitle/TagLabel'
import { DfmFeedbackMessage } from '~/gql/graphql'

import styles from './styles.css'

type InactiveSlideTitlePropsType = Pick<
    InactiveSlidePropsType,
    | 'idx'
    | 'isPublished'
    | 'isTopicUpdatedByUser'
    | 'topic'
    | 'status'
    | 'slideId'
>

const UnsavedInactive3dSlideTitle = (props: InactiveSlideTitlePropsType) => {
    const { idx, topic, status, slideId } = props

    const topicLabel = topic ? topic : `Slide ${Number(idx) + 1}`

    return (
        <Box justifyContent="between">
            <Box justifyContent="between" width="100%">
                <Text
                    data-test-target="im-dfm-topic"
                    fontSize="16px"
                    fontWeight={400}
                    lineHeight="24px"
                >
                    {/*todo: resolve type of topicLabel, one of types is DfmFeedbackTopicType which can't be a children of react component */}
                    {topicLabel as any}
                </Text>
                <TagLabel isUnsaved />
            </Box>
            <SlideActions
                dfmFeedbackId={slideId}
                idx={idx}
                isUnsaved
                status={status}
            />
        </Box>
    )
}

type StatusOverviewPropsType = Pick<InactiveSlidePropsType, 'status'>

export const StatusOverview = (props: StatusOverviewPropsType) => {
    const { status } = props

    if (!status) {
        return null
    }

    return (
        <Box marginTop="8px">
            <StatusOverviewIcon status={status} />
            <Text
                color="blackAlpha65"
                data-test-target="im-dfm-status"
                fontSize="14px"
                fontWeight={300}
            >
                {DFM_STATES[status]}
            </Text>
        </Box>
    )
}

type MessageOverviewPropsType = Pick<InactiveSlidePropsType, 'messageBody'>

export const MessageOverview = (props: MessageOverviewPropsType) => {
    const { messageBody } = props

    if (!messageBody) {
        return null
    }

    return (
        <Box marginTop="8px">
            <Text
                color="blackAlpha65"
                data-test-target="im-dfm-messageBody"
                fontSize="14px"
                fontWeight={300}
            >
                {messageBody}
            </Text>
        </Box>
    )
}

type InactiveSlidePropsType = {
    idx: string
    isPublished?: boolean
    isTopicUpdatedByUser?: boolean
    messageBody?: string
    onClick?: () => void
    slideId: string
    status?: ImDfmStateType | null
    topic?: DfmFeedbackTopicType | null
    dfmTitles: DfmFeedbackMessage[]
}

const UnsavedInactive3dSlide = (props: InactiveSlidePropsType) => {
    const { idx, onClick, status, topic, messageBody, slideId } = props

    return (
        <Card
            className={styles.inactiveSlide}
            data-test-target={`im-dfm-slide-${idx}`}
            onClick={onClick}
            size="small"
            style={{
                marginBottom: '8px',
                borderRadius: '4px',
                width: '100%',
            }}
        >
            <UnsavedInactive3dSlideTitle
                idx={idx}
                slideId={slideId}
                status={status}
                topic={topic}
            />
            <MessageOverview messageBody={messageBody} />
            <StatusOverview status={status} />
        </Card>
    )
}

export default UnsavedInactive3dSlide
